angular.
	module("dx.webapp.masterTools").
	controller("DxBulkSetHiddenExamsRouteController", function BulkSetHiddenExamsRouteController(
		$rootScope,
		dxApi,
		ngPasteFromErrors,
		dxDialog
	) {
		"use strict";

		var self = this;

		self.ids = [];
		self.errors = [];
		self.archivedErrors = [];
		self.idsValidated = false;
		self.deletionDone = false;
		self.loading = false;
		var requestBody = {
			examIds: [],
			hidden: false,
		};
		var ids = [];
		var numberOfRows = 0;
		var rowValidationCounter = 0;

		self.onBeforePaste = function onBeforePaste(data) {
			self.ids = [];
			self.errors = [];
			self.exams = [];
			self.loading = false;
			self.errors = [];
			self.archivedErrors = [];
			self.idsValidated = false;

			ids = [];

			rowValidationCounter = 0;
			numberOfRows = data.split(/\r\n|\r|\n/).length;
			return data;
		};

		self.onValidateEntry = function onValidateEntry(row) {
			var id = row.id.trim();
			if (idInList(id)) {
				incrementValidationCounter();
				return false;
			}

			if (isNumber(id)) {
				ids.push(id);
			} else {
				self.errors.push("Not a valid id: " + id);
				incrementValidationCounter();
				return false;
			}

			incrementValidationCounter();
			return true;
		};

		self.onEntryError = function onEntryError(error, rowData) {
			if (error === ngPasteFromErrors.invalidColumnLength) {
				var expectedColumns = rowData.expectedLength + " column" + (rowData.expectedLength > 1 ? "s" : "");
				return self.errors.push("Expected row " + (rowData.index + 1) + " to be " + expectedColumns + ", but it was " + rowData.actualLength + ": " + rowData.source);
			}

			return null;
		};

		self.bulkToggleHideExams = function bulkToggleHideExams(toggleType) {
			self.errors = [];
			self.archivedErrors = [];

			self.idsValidated = false;
			var examsSelection = [];
			var templateExamsSelection = [];

			if (toggleType === "show") {
				dxDialog.confirm({
					title: "Show exams",
					body: "Are you sure you want to show these exams?",
					acceptText: "Show",
					acceptCallback: runShowExams,
					rejectText: "Cancel",
				});
			}
			if (toggleType === "hide") {
				dxDialog.confirm({
					title: "Hide exams",
					body: "Are you sure you want to hide these exams?",
					acceptText: "Hide",
					acceptCallback: runHideExams,
					rejectText: "Cancel",
				});
			}

			function runShowExams() {
				createExamsLists();
				dxDialog.closeMostRecent();
				self.loading = true;
				requestBody.hidden = false;
				toggleHideExamRequest();
				toggleHideTmpExamRequest();
			}

			function runHideExams() {
				createExamsLists();
				dxDialog.closeMostRecent();
				self.loading = true;
				requestBody.hidden = true;
				toggleHideExamRequest();
				toggleHideTmpExamRequest();
			}

			function createExamsLists() {
				for (var i = 0; i < self.exams.length; i++) {
					if (self.exams[i].isArchived === true) {
						if (self.exams[i].parent === 0) {
							templateExamsSelection.push(self.exams[i].id);
						} else {
							examsSelection.push(self.exams[i].id);
						}
					}
				}
			}

			function toggleHideExamRequest() {
				if (examsSelection.length > 0) {
					requestBody.examIds = examsSelection;
					dxApi.v1.exams.hide(requestBody).then(self.toggleHideSuccessHandler, self.toggleHideFailHandler);
				}
			}
			function toggleHideTmpExamRequest() {
				if (templateExamsSelection.length > 0) {
					requestBody.examIds = templateExamsSelection;
					dxApi.v1.examTemplates.hide(requestBody).then(self.toggleHideSuccessHandler, self.toggleHideFailHandler);
				}
			}
		};

		self.toggleHideSuccessHandler = function toggleHideSuccessHandler() {
			self.loading = false;
			var message = requestBody.hidden ? "Hide exam(s) finished successfully" : "Show exam(s) finished successfully";
			$rootScope.$broadcast("notification:success", message);
		};

		self.toggleHideFailHandler = function toggleHideFailHandler() {
			self.loading = false;
			$rootScope.$broadcast("notification:error", "Hide/show exam(s) failed");
		};


		function identifyNonArchivedExams(exams) {
			for (var i = 0; i < exams.length; i++) {
				if (!exams[i].isArchived) {
					self.archivedErrors.push("The exam is not archived with id: " + exams[i].id);
					removeArchivedExams(exams[i]);
				}
			}
		}

		function identifyNonExistentIds(exams) {
			for (var i = 0; i < ids.length; i++) {
				var notFound = true;
				for (var j = 0; j < exams.length; j++) {
					if (parseInt(ids[i], 10) === exams[j].id) {
						notFound = false;
						break;
					}
				}
				if (notFound) {
					self.errors.push("Could not find exam with id: " + ids[i]);
				}
			}
		}

		function incrementValidationCounter() {
			rowValidationCounter++;
			if (rowValidationCounter === numberOfRows) {
				getExams();
			}
		}

		function removeArchivedExams(exam) {
			var index = self.exams.indexOf(exam);
			if (index > -1) {
				self.exams.splice(index, 1);
			}
		}

		function addExams(exams) {
			for (var i = 0; i < exams.length; i++) {
				if (!idInList(exams[i].id)) {
					self.exams.push(exams[i]);
				}
			}
		}

		function getExams() {
			if (ids.length > 0) {
				self.loading = true;
			}

			if (ids.length > 0) {
				dxApi.v1.exams.getAllById(ids).then(function success(data) {
					identifyNonExistentIds(data);
					addExams(data);
					identifyNonArchivedExams(data);
					self.loading = false;
				}, function fail(resp) {
					if (resp.status === 404) {
						self.errors.push("Could not find any archived exams with ids: " + ids.join(", "));
					} else {
						self.errors.push("Could not complete exams id query: " + resp.error.message);
					}
				}).finally(function done() {
					self.idsValidated = true;
					self.loading = false;
				});
			}
		}

		function idInList(id) {
			for (var i = 0; i < ids.length; i++) {
				if (ids[i] === id) {
					return true;
				}
			}
			return false;
		}

		function isNumber(string) {
			return /^\d+$/.test(string);
		}

		self.isTemplate = function isTemplate(exam) {
			if (exam.parent === 0) {
				return "Template";
			}
			return "Exam";
		};
	});
